"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBar = exports.SideLink = exports.SideBarToogle = exports.SideBar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
var _layout = require("./layout");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = require("./button");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Toggler = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  cursor: pointer;\n"])));
var SideLink = exports.SideLink = (0, _styledComponents["default"])('li').attrs({
  className: 'flexi-navigation-item',
  id: 'flexi-navigation-item'
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: block;\n  list-style: none;\n  /* padding: 0 5px; */\n\n  & a {\n    display: grid;\n    align-items: center;\n    text-decoration: none;\n    color: ", ";\n    min-height: ", ";\n    text-transform: capitalize;\n    font-size: 1.1em;\n    /* border: 1px solid #ececec; */\n    /* border-radius: 5px; */\n    & i {\n      display: flex;\n      height: inherit;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n"])), function (props) {
  return (0, _polished.darken)(0.1, props.theme.PrimaryFontColor);
}, function (props) {
  return props.height;
});
var MenuOverlay = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  background-color: rgba(0, 0, 0, .2);\n  transition: ", ";\n  z-index: 900;\n  display: ", ";\n"])), function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return props.display ? "block" : "none";
});
SideLink.defaultProps = {
  height: '40px'
};
SideLink.propTypes = {
  height: _propTypes["default"].string
};
var SideBarWrapper = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: ", ";\n  display: block;\n  transition: ", ";\n  z-index:  ", ";\n  background: ", ";\n  position: fixed;\n  overflow: hidden;\n  height: 100vh;\n  top: 0;left:0;\n\n  ", "\n\n  ", "\n  ", "\n  & .flexi-side-content{\n      width: ", ";\n      padding-top: 20px;\n      height: calc(100% - ", ");\n      overflow: auto;\n      overflow-x: hidden;\n      white-space: nowrap;\n      transition: ", ";\n\n      ", "\n\n  &::-webkit-scrollbar {\n    width: 8px;\n    display: none;\n  }\n  &::-webkit-scrollbar-track {\n    background-color: ", ";\n    display: none;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n    border-radius: 20px;\n    display: none;\n    border: 3px solid\n      ", ";\n  }\n\n  &:hover {\n    &::-webkit-scrollbar {\n      width: 8px;\n      display: block;\n    }\n    &::-webkit-scrollbar-track {\n      background-color: ", ";\n      display: block;\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: ", ";\n      border-radius: 20px;\n      display: block;\n      border: 3px solid\n        ", ";\n    }\n  }\n      }\n      & .flexi-side-brand{\n          display: flex;\n          align-items: center;\n          height: ", ";\n          width: ", ";\n          justify-content: space-between;\n          & img{\n              width: 100%;\n          }\n\n          ", "{\n            justify-self: flex-end;\n            padding: 5px 15px\n          }\n      }\n      ", "{\n          & a{\n              grid-template-columns: ", " auto;\n              &:hover{\n                  color: ", ";\n              }\n              &.active{\n                  font-weight: bold;\n                  color: ", ";\n              }\n\n              ", "\n          }\n      }\n"])), function (props) {
  return props.openWidth;
}, function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return props.zIndex;
}, function (props) {
  return props.background;
}, function (props) {
  return props.borderline && (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      border-right: 1px solid ", ";\n    "])), props.borderline);
}, function (props) {
  return props["float"] && (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      position: fixed;\n      background: ", ";\n      ", ";\n      height: 100vh;\n\n      &::before {\n        /* position: absolute; */\n        height: 100vh;\n        width: 100vw;\n        background-color: red;\n      }\n      \n    "])), function (props) {
    return props.background != 'none' ? props.background : 'white';
  }, function (props) {
    return props.theme.Elevate.fader;
  });
}, function (props) {
  return props.collapse && (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      width: ", ";\n      ", "\n    "])), function (props) {
    return props.closeWidth;
  }, props["float"] && (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n          width: 0;\n        "]))));
}, function (props) {
  return props.openWidth;
}, function (props) {
  return props.brandHeight;
}, function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return props.anchorFooter && (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n        display: grid;\n        grid-template-rows: auto max-content;\n      "])));
}, function (props) {
  return props.bgColor ? props.bgColor : props.theme.PrimaryFade;
}, function (props) {
  return (0, _polished.transparentize)(0.8, props.theme.PrimaryFontColor);
}, function (props) {
  return props.bgColor ? props.bgColor : props.theme.PrimaryFade;
}, function (props) {
  return props.bgColor ? props.bgColor : props.theme.PrimaryFade;
}, function (props) {
  return (0, _polished.transparentize)(0.8, props.theme.PrimaryFontColor);
}, function (props) {
  return props.bgColor ? props.bgColor : props.theme.PrimaryFade;
}, function (props) {
  return props.brandHeight;
}, function (props) {
  return props.openWidth;
}, SideBarToogle, SideLink, function (props) {
  return props.closeWidth;
}, function (props) {
  return props.activeColor ? props.activeColor : props.theme.PrimaryColor;
}, function (props) {
  return props.activeColor ? props.activeColor : props.theme.PrimaryColor;
}, function (props) {
  return props.pillSideLink && (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n                  &:hover {\n                    background-color: ", ";\n                  }\n                  &.active {\n                  font-weight: bold;\n                    background-color: ", ";\n                    border-left: 3px solid ", ";\n                  }\n                "])), function (props) {
    return props.activeColor ? (0, _polished.transparentize)(.99, props.activeColor) : (0, _polished.transparentize)(.99, props.theme.PrimaryColor);
  }, function (props) {
    return props.activeColor ? (0, _polished.transparentize)(.95, props.activeColor) : (0, _polished.transparentize)(.95, props.theme.PrimaryColor);
  }, function (props) {
    return props.activeColor ? props.activeColor : props.theme.PrimaryColor;
  });
});
var TopBarWrapper = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      height: ", ";\n      display: grid;\n      grid-template-columns: 50px auto max-content;\n      align-items: center;\n      position: fixed;\n      transition: ", ";\n      z-index:  ", ";\n      overflow: hidden;\n      top:0;\n      left:0;\n      width: 100%;\n      background: ", ";\n\n      ", "\n\n      ", "\n      ", "\n      ", ";\n      padding-left: ", ";\n      ", "\n\n      & .flexi-top-title{\n          padding: 0 20px;\n      }\n      & .flexi-top-toogle{\n          & .flexi-button-center{\n              & i{\n                  transition: ", ";\n                  ", "\n              }\n          }\n      }\n"])), function (props) {
  return props.height;
}, function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return props.zIndex;
}, function (props) {
  return props.background;
}, function (props) {
  return props.borderline && (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n          border-bottom: 1px solid ", ";\n        "])), props.borderline);
}, function (props) {
  return props.anchor && (0, _styledComponents.css)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n          position: sticky;\n        "])));
}, function (props) {
  return props.scrollable && (0, _styledComponents.css)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n          position: absolute;\n        "])));
}, function (props) {
  return props.theme.Elevate[props.elevate];
}, function (props) {
  return props.spaceLeft;
}, function (props) {
  return props.sideFloat && (0, _styledComponents.css)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n          padding-left: 0;\n        "])));
}, function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return props.sideCollapse && (0, _styledComponents.css)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n                      transform: rotateZ(180deg);\n                      transform-origin: center;\n                    "])));
});
var SideBarToogle = exports.SideBarToogle = function SideBarToogle(props) {
  var _useContext = (0, _react.useContext)(_layout.LayoutContext),
    layoutVar = _useContext.layoutVar,
    setLayout = _useContext.setLayout;
  return /*#__PURE__*/_react["default"].createElement(Toggler, {
    onClick: function onClick() {
      return setLayout({
        collapseSide: !layoutVar.collapseSide
      });
    }
  }, props.children);
};
var SideBar = exports.SideBar = function SideBar(props) {
  var listmenu = props.menuList ? Array.isArray(props.menuList) ? props.menuList : [props.menuList] : null;
  var _useContext2 = (0, _react.useContext)(_layout.LayoutContext),
    layoutVar = _useContext2.layoutVar,
    setLayout = _useContext2.setLayout;
  var linkCloser = function linkCloser() {
    setLayout({
      collapseSide: !layoutVar.collapseSide
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(SideBarWrapper, props, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-side-brand"
  }, props.brand, layoutVar.floatSide ? /*#__PURE__*/_react["default"].createElement(SideBarToogle, null, /*#__PURE__*/_react["default"].createElement("i", {
    className: "flexibull-cancel-1",
    style: {
      fontSize: '16px'
    }
  })) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-side-content"
  }, /*#__PURE__*/_react["default"].createElement("div", null, listmenu && listmenu.map(function (elem, index) {
    return elem.navlink ? /*#__PURE__*/_react["default"].createElement(SideLink, {
      key: "flexi-menu-list-".concat(index, "-").concat(elem.label),
      onClick: layoutVar.floatSide ? {
        linkCloser: linkCloser
      } : function () {}
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
      to: elem.navlink
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: elem.icon
    }), /*#__PURE__*/_react["default"].createElement("span", null, elem.label))) : /*#__PURE__*/_react["default"].createElement(SideLink, {
      key: "flexi-menu-list-".concat(index, "-").concat(elem.label)
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: elem.link
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: elem.icon
    }), /*#__PURE__*/_react["default"].createElement("span", null, elem.label)));
  })), props.children && /*#__PURE__*/_react["default"].createElement("div", null, props.children))), layoutVar.floatSide ? /*#__PURE__*/_react["default"].createElement(MenuOverlay, {
    onClick: function onClick() {
      return setLayout({
        collapseSide: !layoutVar.collapseSide
      });
    },
    display: layoutVar.collapseSide ? false : true
  }) : null);
};
var TopBar = exports.TopBar = function TopBar(props) {
  var _useContext3 = (0, _react.useContext)(_layout.LayoutContext),
    layoutVar = _useContext3.layoutVar;
  return /*#__PURE__*/_react["default"].createElement(TopBarWrapper, _extends({}, props, {
    sideCollapse: layoutVar.collapseSide,
    sideFloat: layoutVar.sideFloat
  }), props.toogle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-top-toogl"
  }, /*#__PURE__*/_react["default"].createElement(SideBarToogle, null, /*#__PURE__*/_react["default"].createElement(_button.Button, {
    plain: true,
    spaceLeft: true,
    icon: /*#__PURE__*/_react["default"].createElement("i", {
      className: !layoutVar.collapseSide ? props.collapseIcon : props.expandIcon
    })
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-top-title"
  }, props.title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-top-content"
  }, props.children));
};
SideBar.defaultProps = {
  borderline: 'none',
  openWidth: '100px',
  closeWidth: '60px',
  anchorFooter: false,
  collapse: false,
  "float": false,
  zIndex: 990,
  background: 'none',
  pillSideLink: false
};
SideBar.propTypes = {
  borderline: _propTypes["default"].string,
  openWidth: _propTypes["default"].string,
  closeWidth: _propTypes["default"].string,
  collapse: _propTypes["default"].bool,
  "float": _propTypes["default"].bool,
  zIndex: _propTypes["default"].number,
  background: _propTypes["default"].string,
  brand: _propTypes["default"].any,
  brandHeight: _propTypes["default"].string,
  menuList: _propTypes["default"].any,
  anchorFooter: _propTypes["default"].bool,
  pillSideLink: _propTypes["default"].bool
};
TopBar.defaultProps = {
  borderline: 'none',
  height: '80px',
  anchor: false,
  zIndex: 989,
  background: '#fff',
  elevate: 'fader',
  collapseIcon: 'flexibull-left',
  expandIcon: 'flexibull-right'
};
TopBar.propTypes = {
  borderline: _propTypes["default"].string,
  height: _propTypes["default"].string,
  anchor: _propTypes["default"].bool,
  zIndex: _propTypes["default"].number,
  background: _propTypes["default"].string,
  elevate: _propTypes["default"].string,
  scrollable: _propTypes["default"].bool,
  title: _propTypes["default"].any,
  spaceLeft: _propTypes["default"].string,
  toogle: _propTypes["default"].bool,
  collapseIcon: _propTypes["default"].string,
  expandIcon: _propTypes["default"].string
};